/**
 * Schedule Constants
 * Day definitions for the schedule component
 */

// Days array with short and full labels (Monday first, Sunday last)
export const DAYS = [
  { label: 'Δευ', value: 1, fullLabel: 'Δευτέρα' },
  { label: 'Τρί', value: 2, fullLabel: 'Τρίτη' },
  { label: 'Τετ', value: 3, fullLabel: 'Τετάρτη' },
  { label: 'Πέμ', value: 4, fullLabel: 'Πέμπτη' },
  { label: 'Παρ', value: 5, fullLabel: 'Παρασκευή' },
  { label: 'Σάβ', value: 6, fullLabel: 'Σάββατο' },
  { label: 'Κυρ', value: 0, fullLabel: 'Κυριακή' },
];

// Days of week for form selections
export const DAYS_OF_WEEK = [
  { value: 1, label: 'Δευτέρα' },
  { value: 2, label: 'Τρίτη' },
  { value: 3, label: 'Τετάρτη' },
  { value: 4, label: 'Πέμπτη' },
  { value: 5, label: 'Παρασκευή' },
  { value: 6, label: 'Σάββατο' },
  { value: 0, label: 'Κυριακή' }
];

